import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import PlayersDirectory from '../features/players/components/PlayersDirectory';
import ProfileView from '../components/views/ProfileView';
import ProfileEditView from '../components/views/ProfileEditView';
import ProfileConnectionsView from '../components/views/ProfileConnectionsView';
import AccountAffiliationView from '../components/views/AccountAffiliationView';
import ForgotPasswordPage from '../features/auth/pages/ForgotPasswordPage';
import ComingSoonPage from '../features/management/pages/ComingSoonPage';
import LoginPage from '../features/auth/pages/LoginPage';
import ManagementHubPage from '../features/management/pages/ManagementHubPage';
import {
  AuctionManagementPage,
  AuctionTeamSetupPage,
  AuctionTeamsOverviewPage,
  OnlineAuctionSetupPage,
  AuctionTeamDetailPage,
  StartOnlineAuctionPage,
  TeamOwnerAdminsPage,
  TeamOwnerBiddingPage,
  PublicOnlineAuctionPage,
} from '../modules/online-auction/pages';
import {
  LiveAuctionSetupPage,
  StartLiveAuctionPage,
  LiveAuctionTeamDetailPage,
  PublicLiveAuctionPage,
  LiveAuctionOperatorPage,
} from '../modules/live-auction/pages';
import RegisterPage from '../features/auth/pages/RegisterPage';
import ResetPasswordPage from '../features/auth/pages/ResetPasswordPage';
import PlayerManagementPage from '../features/players/pages/PlayerManagementPage';
import MatchManagerMatchFormatsPage from '../features/match/pages/MatchManagerMatchFormatsPage';
import MatchManagerManualFormatPage from '../features/match/pages/MatchManagerManualFormatPage';
import MatchManagerDynamicSchedulePage from '../features/match/pages/MatchManagerDynamicSchedulePage';
import PlayerManagerTournamentsPage from '../features/players/pages/PlayerManagerTournamentsPage';
import PublicTeamRegistrationPage from '../features/players/pages/PublicTeamRegistrationPage';
import PublicTeamJoinPage from '../features/players/pages/PublicTeamJoinPage';
import TeamRegistrationsPage from '../features/players/pages/TeamRegistrationsPage';
import MatchManagerTournamentsPage from '../features/match/pages/MatchManagerTournamentsPage';
import MatchConfigurationPage from '../features/match/pages/MatchConfigurationPage';
import SuperAdminLoginPage from '../features/super-admin/pages/SuperAdminLoginPage';
import SuperAdminLayout from '../features/super-admin/layout/SuperAdminLayout';
import SuperAdminDashboard from '../features/super-admin/pages/SuperAdminDashboard';
import SuperAdminIndividualPage from '../features/super-admin/pages/SuperAdminIndividualPage';
import SaOrganizationsPage from '../features/super-admin/pages/SaOrganizationsPage';
import SaClubsPage from '../features/super-admin/pages/SaClubsPage';
import SaCommunitiesPage from '../features/super-admin/pages/SaCommunitiesPage';
import SuperAdminSettingsPage from '../features/super-admin/pages/SuperAdminSettingsPage';
import EntityDetailsPage from '../features/super-admin/pages/EntityDetailsPage';
import CommunityTeamAdminPage from '../features/community/pages/CommunityTeamAdminPage';
import OrganizationTeamAdminPage from '../features/organization/pages/OrganizationTeamAdminPage';
import ClubTeamAdminPage from '../features/club/pages/ClubTeamAdminPage';
import TeamAdminPlayersPage from '../features/team-admin/pages/TeamAdminPlayersPage';
import PlayerApprovalsPage from '../features/team-admin/pages/PlayerApprovalsPage';
import TournamentAdminTournamentsPage from '../features/tournament/pages/TournamentAdminTournamentsPage';
import TournamentAdminAssignedTournamentsPage from '../features/tournament/pages/TournamentAdminAssignedTournamentsPage';
import CommunityAdminsPage from '../features/community/pages/CommunityAdminsPage';
import OrganizationAdminsPage from '../features/organization/pages/OrganizationAdminsPage';
import StaticInfoPage from '../features/common/pages/StaticInfoPage';
import PricingPage from '../features/commercial/PricingPage';
import CommercialAdminPage from '../features/commercial/CommercialAdminPage';
import OffersAdminPage from '../features/commercial/OffersAdminPage';
import GrowthAdminPage from '../features/commercial/GrowthAdminPage';
import LaunchCommerceAdminPage from '../features/commercial/LaunchCommerceAdminPage';
import NotificationAdminPage from '../features/notifications/NotificationAdminPage';
import LaunchCommercePage from '../features/commercial/LaunchCommercePage';
import ExplorePremiumPage from '../features/commercial/ExplorePremiumPage';
import IdentityAdminPage from '../features/identity/IdentityAdminPage';
import PublicIdentityProfilePage from '../features/identity/PublicIdentityProfilePage';
import IdentitySearchPage from '../features/identity/IdentitySearchPage';
import CopAdminPage from '../features/cop/CopAdminPage';
import CopWorkspacePage from '../features/cop/CopWorkspacePage';
import SuperAdminGrounds from '../features/grounds/admin/SuperAdminGrounds';
import SuperAdminGroundForm from '../features/grounds/admin/SuperAdminGroundForm';
import SuperAdminGroundDetail from '../features/grounds/admin/SuperAdminGroundDetail';
import SuperAdminGroundRequests from '../features/grounds/admin/SuperAdminGroundRequests';
import SuperAdminGroundBookings from '../features/grounds/admin/SuperAdminGroundBookings';
import PublicOrganizationPage from '../features/cop/PublicOrganizationPage';
import HelpCenterPage from '../features/help-center/HelpCenterPage';
import GuidancePage from '../features/common/pages/GuidancePage';
import LaunchPage from '../features/common/pages/LaunchPage';
import NotFoundPage from '../features/common/pages/NotFoundPage';
import TeamOwnerTournamentsPage from '../features/team-owner/pages/TeamOwnerTournamentsPage';
import MatchManagementPage from '../features/match/pages/MatchManagementPage';
import MatchStartPage from '../features/match/pages/MatchStartPage';
import MatchScoreboardPage from '../features/match/pages/MatchScoreboardPage';
import PublicMatchViewPage from '../features/match/pages/PublicMatchViewPage';
import PublicMatchWatchPage from '../features/match/pages/PublicMatchWatchPage';
import ObsOverlayPage from '../features/match/pages/ObsOverlayPage';
import TournamentLeaderboardPage from '../features/tournament/pages/TournamentLeaderboardPage';
import PublicTournamentLeaderboardPage from '../features/tournament/pages/PublicTournamentLeaderboardPage';
import PublicTournamentJoinPage from '../features/tournament/pages/PublicTournamentJoinPage';
import JoinTournamentPage from '../features/tournament/pages/JoinTournamentPage';
import JoinTeamPage from '../features/match/pages/JoinTeamPage';
import IndividualTournamentsPage from '../features/individual/pages/IndividualTournamentsPage';
import IndividualTournamentCreatePage from '../features/individual/pages/IndividualTournamentCreatePage';
import IndividualTournamentEditPage from '../features/individual/pages/IndividualTournamentEditPage';
import IndividualTournamentMatchesPage from '../features/individual/pages/IndividualTournamentMatchesPage';
import IndividualTournamentAdminPage from '../features/individual/pages/IndividualTournamentAdminPage';
import IndividualHomePage from '../features/individual/pages/IndividualHomePage';
import IndividualMyMatchesPage from '../features/individual/pages/IndividualMyMatchesPage';
import StreamingDashboardPage from '../features/individual/pages/StreamingDashboardPage';
import TournamentStreamingOperationsPage from '../features/individual/pages/TournamentStreamingOperationsPage';
import NearbyDiscoveryPage from '../features/discovery/pages/NearbyDiscoveryPage';
import GaliHomePage from '../features/gali/pages/GaliHomePage';
import GaliQuickMatchPage from '../features/gali/pages/GaliQuickMatchPage';
import GaliMatchDetailPage from '../features/gali/pages/GaliMatchDetailPage';
import GaliScorecardPage from '../features/gali/pages/GaliScorecardPage';
import GaliHistoryPage from '../features/gali/pages/GaliHistoryPage';
import GaliLeaderboardPage from '../features/gali/pages/GaliLeaderboardPage';
import GaliTempPlayerProfilePage from '../features/gali/pages/GaliTempPlayerProfilePage';
import GaliManageAccessPage from '../features/gali/pages/GaliManageAccessPage';
import GaliInviteAcceptPage from '../features/gali/pages/GaliInviteAcceptPage';
import GaliPublicMatchPage from '../features/gali/pages/GaliPublicMatchPage';
import GaliShareMatchPage from '../features/gali/pages/GaliShareMatchPage';
import ProtectedRoute from '../components/routing/ProtectedRoute';
import SuperAdminRoute from '../components/routing/SuperAdminRoute';
import { useRoleContext } from '../context/RoleContext';
import { useAuth } from '../context/AuthContext';
import { getUserRoles, hasScopedRole, normalizeRole } from '../utils/userRoles';



const LOGIN_ENTRY_PATHS = ['/login', '/sa/login', '/auth/register', '/auth/forgot-password', '/auth/reset-password'];
const APP_MODE_STORAGE_KEY = 'appMode';
const INDIVIDUAL_HOME_PATH = '/dashboard/individual/home';

const getSafeFromPath = (fromState) => {
  if (!fromState) return '';

  const nextPath = typeof fromState === 'string'
    ? fromState
    : `${fromState.pathname || ''}${fromState.search || ''}${fromState.hash || ''}`;

  if (!nextPath.startsWith('/')) return '';
  if (nextPath.startsWith('/management')) return '';
  if (nextPath === '/dashboard/individual') return INDIVIDUAL_HOME_PATH;
  if (nextPath.startsWith('/dashboard/')) return nextPath;
  if (nextPath.startsWith('/org/') || nextPath.startsWith('/community/') || nextPath.startsWith('/club/')) return nextPath;
  if (nextPath.startsWith('/individual-tournament/')) return nextPath;
  if (nextPath.startsWith('/tournament-admin/')) return nextPath;
  return '';
};

const ContextAccessNotice = () => (
  <StaticInfoPage
    title="Admin context required"
    description="Select the matching Admin tab to access this dashboard."
    badgeText="Context"
  />
);

const resolveContextEntityId = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.id || value._id || '';
};


const resolveRouteScope = (params = {}) => {
  if (params.organizationId) {
    return { scopeType: 'organization', scopeId: String(params.organizationId) };
  }
  if (params.communityId) {
    return { scopeType: 'community', scopeId: String(params.communityId) };
  }
  if (params.clubId) {
    return { scopeType: 'club', scopeId: String(params.clubId) };
  }
  return { scopeType: null, scopeId: null };
};

const RouteAccessGuard = ({ allowedRoles = [], children }) => {
  const location = useLocation();
  const params = useParams();
  const { token, user, isLoadingAuth } = useAuth();
  const { isLoadingContexts, rolesLoaded } = useRoleContext();

  if (isLoadingAuth || (token && (!rolesLoaded || isLoadingContexts))) {
    return <div className="text-center py-5">Loading...</div>;
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!allowedRoles.length) {
    return children;
  }

  const { scopeType, scopeId } = resolveRouteScope(params);
  const normalizedAllowedRoles = allowedRoles.map((role) => normalizeRole(role)).filter(Boolean);
  const hasAccess = normalizedAllowedRoles.some((role) => hasScopedRole(user, role, scopeType, scopeId));

  if (hasAccess) {
    return children;
  }


  return <ContextAccessNotice />;
};

const AdminDashboardRouteRedirect = ({ scope }) => {
  const { user } = useAuth();
  const { activeContext, availableContexts } = useRoleContext();

  const entityType = scope === 'organization' ? 'organization' : scope === 'community' ? 'community' : 'club';
  const allowedTypes = new Set([`${scope}_admin`, 'department_admin', 'tournament_admin']);
  const activeMatchesScope = activeContext?.entityType === entityType && allowedTypes.has(activeContext?.type);

  const fallbackContext = (availableContexts || []).find((context) =>
    context?.entityType === entityType && allowedTypes.has(context?.type)
  );

  const entityId = activeMatchesScope
    ? String(activeContext?.entityId || '')
    : fallbackContext?.entityId
      ? String(fallbackContext.entityId)
      : scope === 'organization'
        ? resolveContextEntityId(user?.organization)
        : scope === 'community'
          ? resolveContextEntityId(user?.community)
          : resolveContextEntityId(user?.club);

  if (!entityId) {
    return <ContextAccessNotice />;
  }

  if (activeContext?.type === 'department_admin') {
    return <Navigate to={`/dashboard/${scope}/${entityId}/players/approvals`} replace />;
  }

  return <Navigate to={`/dashboard/${scope}/${entityId}/tournaments`} replace />;
};

function AppRoutes({
  createdProfile,
  formData,
  handleChange,
  handleFileChange,
  handleSubmit,
  isLoadingProfile,
  isSavingProfile,
  manageListItem,
  onRefreshProfile,
  statusMessage,
  toggleAddOn,
  toggleSkillTag,
  updateAddOnField,
}) {
  const { authReady, token, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const auctionManagementPath =
    '/org/:organizationId/auction-manager/:auctionManagerId/tournaments/:tournamentId';
  const communityAuctionManagementPath =
    '/community/:communityId/auction-manager/:auctionManagerId/tournaments/:tournamentId';
  const clubAuctionManagementPath =
    '/club/:clubId/auction-manager/:auctionManagerId/tournaments/:tournamentId';
  const individualAuctionManagementPath =
    '/individual-tournament/:tournamentId/auction';



  // Post-login redirect is handled in AppRoutes.jsx only. Do not add redirects elsewhere.
  useEffect(() => {
    if (!authReady || !token) return;

    const userRoles = getUserRoles(user);
    const isSuperAdmin = userRoles.has('super_admin') || user?.isSuperAdmin;
    const pathname = location.pathname;

    if (typeof window !== 'undefined') {
      if (pathname.startsWith('/sa')) {
        window.localStorage.setItem(APP_MODE_STORAGE_KEY, 'sa');
      } else if (pathname.startsWith('/dashboard')) {
        window.localStorage.setItem(APP_MODE_STORAGE_KEY, 'individual');
      }
    }

    if (isSuperAdmin && pathname.startsWith('/sa')) {
      const mode = typeof window !== 'undefined' ? window.localStorage.getItem(APP_MODE_STORAGE_KEY) : 'sa';
      if (mode === 'sa') {
        return;
      }
    }

    if (isSuperAdmin && pathname.startsWith('/dashboard')) {
      const mode = typeof window !== 'undefined' ? window.localStorage.getItem(APP_MODE_STORAGE_KEY) : 'individual';
      if (mode === 'individual') {
        return;
      }
    }

    const shouldRedirect = LOGIN_ENTRY_PATHS.some((path) => pathname.startsWith(path));

    if (isSuperAdmin && pathname.startsWith('/dashboard/individual')) {
      const destination = `/sa/dashboard/individual${location.search || ''}`;
      if (`${pathname}${location.search}` !== destination) {
        navigate(destination, { replace: true });
      }
      return;
    }

    if (!shouldRedirect) return;

    const destination = isSuperAdmin
      ? '/sa/dashboard'
      : getSafeFromPath(location.state?.from) || INDIVIDUAL_HOME_PATH;

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(APP_MODE_STORAGE_KEY, isSuperAdmin ? 'sa' : 'individual');
    }

    const currentPath = `${pathname}${location.search}`;
    if (currentPath === destination) return;

    navigate(destination, { replace: true });
  }, [authReady, location.pathname, location.search, location.state, navigate, token, user]);

  const roleGuard = (element, allowedRoles = []) => (
    <RouteAccessGuard allowedRoles={allowedRoles}>{element}</RouteAccessGuard>
  );

  return (
    <Routes>
      <Route path="/team-registration/:token" handle={{ crumb: "Team Registration" }} element={<PublicTeamRegistrationPage />} />
      <Route path="/team-registration/join/:token" handle={{ crumb: "Join Team" }} element={<PublicTeamJoinPage />} />
      <Route path="/login" handle={{ crumb: "Login" }}
        element={<LoginPage />} />
      <Route path="/sa/login" handle={{ crumb: "Login" }}
        element={<SuperAdminLoginPage />} />
      <Route path="/auth/register" handle={{ crumb: "Register" }}
        element={<RegisterPage />} />
      <Route path="/auth/forgot-password" handle={{ crumb: "Forgot Password" }}
        element={<ForgotPasswordPage />} />
      <Route path="/auth/reset-password" handle={{ crumb: "Reset Password" }}
        element={<ResetPasswordPage />} />
      <Route
        path="/public/tournaments/:tournamentId/matches/:matchId"
        handle={{ crumb: "Matches" }}
        element={<PublicMatchViewPage />}
      />
      <Route
        path="/matches/:matchId/watch"
        handle={{ crumb: "Watch" }}
        element={<PublicMatchWatchPage />}
      />
      <Route
        path="/overlay"
        handle={{ crumb: "Overlay" }}
        element={<ObsOverlayPage />}
      />
      <Route
        path="/join/tournaments/:inviteCode"
        handle={{ crumb: "Join Tournament" }}
        element={<PublicTournamentJoinPage />}
      />
      <Route path="/join-team/:token" handle={{ crumb: "Join Team" }} element={<JoinTeamPage />} />
      <Route path="/join-tournament/:token" handle={{ crumb: "Join Tournament" }} element={<JoinTournamentPage />} />
      <Route
        path="/public/tournaments/:tournamentId/leaderboard"
        handle={{ crumb: "Leaderboard" }}
        element={<PublicTournamentLeaderboardPage />}
      />

      <Route
        path="/public/tournaments/:tournamentId/live-auction"
        handle={{ crumb: "Live Auction" }}
        element={<PublicLiveAuctionPage />}
      />

      <Route
        path="/public/auction/:tournamentId"
        handle={{ crumb: "Online Auction" }}
        element={<PublicOnlineAuctionPage />}
      />

      <Route
        path="/auction/:tournamentId/online/public"
        handle={{ crumb: "Online Auction" }}
        element={<PublicOnlineAuctionPage />}
      />

      <Route path="/gali/public/:publicToken" handle={{ crumb: "Gali Public" }} element={<GaliPublicMatchPage />} />
      <Route path="/gali/public/:publicToken/scoreboard" handle={{ crumb: "Gali Scoreboard" }} element={<GaliPublicMatchPage />} />
      <Route path="/gali/invites/:inviteToken" handle={{ crumb: "Gali Invite" }} element={<GaliInviteAcceptPage />} />
      <Route path="/404" handle={{ crumb: "404" }}
        element={<NotFoundPage />} />
      <Route path="/pricing" handle={{ crumb: "Pricing" }} element={<PricingPage />} />
      <Route path="/explore-premium" handle={{ crumb: "Explore Premium" }} element={<ExplorePremiumPage />} />
      <Route path="/cricket" handle={{ crumb: "Cricket Identity" }} element={<IdentitySearchPage />} />
      <Route path="/cricket/:entityType/:slug" handle={{ crumb: "Cricket Profile" }} element={<PublicIdentityProfilePage />} />
      <Route path="/cricket-organizations/:slug" handle={{ crumb: "Organization" }} element={<PublicOrganizationPage />} />
      <Route element={<SuperAdminRoute />}>
        <Route path="/sa" handle={{ crumb: "Sa" }}
        element={<SuperAdminLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" handle={{ crumb: "Dashboard" }}
        element={<SuperAdminDashboard />} />
          <Route path="dashboard/individual" handle={{ crumb: "Individual" }}
        element={<SuperAdminIndividualPage />} />
          <Route path="organizations" handle={{ crumb: "Organizations" }}
        element={<SaOrganizationsPage />} />
          <Route path="clubs" handle={{ crumb: "Clubs" }}
        element={<SaClubsPage />} />
          <Route path="communities" handle={{ crumb: "Communities" }}
        element={<SaCommunitiesPage />} />
          <Route path="settings" handle={{ crumb: "Settings" }}
        element={<SuperAdminSettingsPage />} />
          <Route path="monetization" handle={{ crumb: "Monetization" }} element={<CommercialAdminPage />} />
          <Route path="offers" handle={{ crumb: "Offers" }} element={<OffersAdminPage />} />
          <Route path="growth" handle={{ crumb: "Growth & Commerce" }} element={<GrowthAdminPage />} />
          <Route path="launch-commerce" handle={{ crumb: "Launch Commerce" }} element={<LaunchCommerceAdminPage />} />
          <Route path="notifications" handle={{ crumb: "Notifications" }} element={<NotificationAdminPage />} />
          <Route path="identity" handle={{ crumb: "Cricket Identity" }} element={<IdentityAdminPage />} />
          <Route path="organization-platform" handle={{ crumb: "Organization Platform" }} element={<CopAdminPage />} />
          <Route path="grounds" handle={{ crumb: "Grounds" }} element={<SuperAdminGrounds />} />
          <Route path="grounds/new" handle={{ crumb: "Create Ground" }} element={<SuperAdminGroundForm />} />
          <Route path="grounds/requests" handle={{ crumb: "Availability Requests" }} element={<SuperAdminGroundRequests />} />
          <Route path="grounds/bookings" handle={{ crumb: "Ground Bookings" }} element={<SuperAdminGroundBookings />} />
          <Route path="grounds/:groundId" handle={{ crumb: "Ground Detail" }} element={<SuperAdminGroundDetail />} />
          <Route path="grounds/:groundId/edit" handle={{ crumb: "Edit Ground" }} element={<SuperAdminGroundForm />} />
          <Route path="organizations/:organizationId" handle={{ crumb: "Organizations" }}
        element={<EntityDetailsPage entityType="organization" />} />
          <Route path="communities/:communityId" handle={{ crumb: "Communities" }}
        element={<EntityDetailsPage entityType="community" />} />
          <Route path="clubs/:clubId" handle={{ crumb: "Clubs" }}
        element={<EntityDetailsPage entityType="club" />} />
          <Route path="organizations/:organizationId/admins" handle={{ crumb: "Admins" }}
        element={<OrganizationAdminsPage />} />
          <Route path="communities/:communityId/admins" handle={{ crumb: "Admins" }}
        element={<CommunityAdminsPage />} />
        </Route>
      </Route>
      <Route element={<ProtectedRoute />}>
      <Route path="/launch-commerce" handle={{ crumb: "Launch Commerce" }} element={<LaunchCommercePage />} />
      <Route path="/cop/:organizationId" handle={{ crumb: "Organization Workspace" }} element={<CopWorkspacePage />} />

      <Route path="/gali" handle={{ crumb: "Gali Cricket" }} element={<GaliHomePage />} />
      <Route path="/gali/create" handle={{ crumb: "Start Quick Match" }} element={<GaliQuickMatchPage />} />
      <Route path="/gali/matches/:matchId" handle={{ crumb: "Gali Match" }} element={<GaliMatchDetailPage />} />
      <Route path="/gali/matches/:matchId/score" handle={{ crumb: "Gali Scoring" }} element={<MatchStartPage />} />
      <Route path="/gali/matches/:matchId/scorecard" handle={{ crumb: "Gali Scorecard" }} element={<GaliScorecardPage />} />
      <Route path="/gali/matches/:matchId/access" handle={{ crumb: "Gali Access" }} element={<GaliManageAccessPage />} />
      <Route path="/gali/history" handle={{ crumb: "Gali History" }} element={<GaliHistoryPage />} />
      <Route path="/gali/leaderboard" handle={{ crumb: "Gali Leaderboard" }} element={<GaliLeaderboardPage />} />
      <Route path="/gali/temp-players/:tempPlayerId" handle={{ crumb: "Gali Temp Player" }} element={<GaliTempPlayerProfilePage />} />
      <Route path="/gali/matches/:matchId/share" handle={{ crumb: "Gali Share" }} element={<GaliShareMatchPage />} />
      <Route path="/management" handle={{ crumb: "Management" }}
        element={<ManagementHubPage />} />
      <Route path="/team-owner/tournaments" handle={{ crumb: "Tournaments" }}
        element={<TeamOwnerTournamentsPage />} />
      <Route path="/individual/tournaments" handle={{ crumb: "Tournaments" }}
        element={<Navigate to="/dashboard/individual/home" replace />} />
      <Route
        path="/individual/tournaments/:tournamentId/matches"
        handle={{ crumb: "Matches" }}
        element={<IndividualTournamentMatchesPage />}
      />
      <Route
        path="/individual/tournaments/:tournamentId/matches/:matchId/start"
        handle={{ crumb: "Start Match" }}
        element={<MatchStartPage />}
      />
      <Route
        path="/org/:organizationId/player-manager/:playerManagerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/community/:communityId/player-manager/:playerManagerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/club/:clubId/player-manager/:playerManagerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/individual-tournament/:tournamentId/players"
        handle={{ crumb: "Players" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/match-formats"
        handle={{ crumb: "Match Formats" }}
        element={roleGuard(<MatchManagerMatchFormatsPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/match-formats/dynamic"
        handle={{ crumb: "Dynamic Scheduler" }}
        element={roleGuard(<MatchManagerDynamicSchedulePage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/match-formats/manual"
        handle={{ crumb: "Manual Format" }}
        element={roleGuard(<MatchManagerManualFormatPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/match-formats"
        handle={{ crumb: "Match Formats" }}
        element={roleGuard(<MatchManagerMatchFormatsPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/match-formats/dynamic"
        handle={{ crumb: "Dynamic Scheduler" }}
        element={roleGuard(<MatchManagerDynamicSchedulePage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/match-formats/manual"
        handle={{ crumb: "Manual Format" }}
        element={roleGuard(<MatchManagerManualFormatPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/match-formats"
        handle={{ crumb: "Match Formats" }}
        element={roleGuard(<MatchManagerMatchFormatsPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/match-formats/dynamic"
        handle={{ crumb: "Dynamic Scheduler" }}
        element={roleGuard(<MatchManagerDynamicSchedulePage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/match-formats/manual"
        handle={{ crumb: "Manual Format" }}
        element={roleGuard(<MatchManagerManualFormatPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:tournamentId/match-formats"
        handle={{ crumb: "Match Formats" }}
        element={roleGuard(<MatchManagerMatchFormatsPage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'tournament_creator', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:tournamentId/match-formats/dynamic"
        handle={{ crumb: "Dynamic Scheduler" }}
        element={roleGuard(<MatchManagerDynamicSchedulePage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'tournament_creator', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:tournamentId/match-formats/manual"
        handle={{ crumb: "Manual Format" }}
        element={roleGuard(<MatchManagerManualFormatPage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'tournament_creator', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId/match-formats"
        handle={{ crumb: "Match Formats" }}
        element={roleGuard(<MatchManagerMatchFormatsPage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'tournament_creator', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId/match-formats/dynamic"
        handle={{ crumb: "Dynamic Scheduler" }}
        element={roleGuard(<MatchManagerDynamicSchedulePage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'tournament_creator', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId/match-formats/manual"
        handle={{ crumb: "Manual Format" }}
        element={roleGuard(<MatchManagerManualFormatPage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'tournament_creator', 'super_admin'])}
      />
      <Route
        path="/org/:organizationId/player-manager/:playerManagerId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<PlayerManagerTournamentsPage />}
      />
      <Route
        path="/community/:communityId/player-manager/:playerManagerId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<PlayerManagerTournamentsPage />}
      />
      <Route
        path="/club/:clubId/player-manager/:playerManagerId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<PlayerManagerTournamentsPage />}
      />
      <Route path="/player-manager/tournaments/:tournamentId/team-registrations" handle={{ crumb: "Team Registrations" }} element={<TeamRegistrationsPage />} />
      <Route path={auctionManagementPath} handle={{ crumb: "Auction Management" }} element={<AuctionManagementPage />} />
      <Route path={communityAuctionManagementPath} handle={{ crumb: "Auction Management" }} element={<AuctionManagementPage />} />
      <Route path={clubAuctionManagementPath} handle={{ crumb: "Auction Management" }} element={<AuctionManagementPage />} />
      <Route path={individualAuctionManagementPath} handle={{ crumb: "Auction Management" }} element={<AuctionManagementPage />} />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagementPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagementPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagementPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagementPage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'super_admin'])}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/configure"
        handle={{ crumb: "Configure Match" }}
        element={roleGuard(<MatchConfigurationPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/configure"
        handle={{ crumb: "Configure Match" }}
        element={roleGuard(<MatchConfigurationPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/configure"
        handle={{ crumb: "Configure Match" }}
        element={roleGuard(<MatchConfigurationPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/configure"
        handle={{ crumb: "Configure Match" }}
        element={roleGuard(<MatchConfigurationPage />, ['individual', 'individual_admin', 'match_manager', 'tournament_admin', 'super_admin'])}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/start"
        handle={{ crumb: "Start Match" }}
        element={<MatchStartPage />}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/start"
        handle={{ crumb: "Start Match" }}
        element={<MatchStartPage />}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/start"
        handle={{ crumb: "Start Match" }}
        element={<MatchStartPage />}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:matchManagerId/tournaments/:tournamentId/matches/:matchId/start"
        handle={{ crumb: "Start Match" }}
        element={<MatchStartPage />}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/scoreboard"
        handle={{ crumb: "Scoreboard" }}
        element={<MatchScoreboardPage />}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/scoreboard"
        handle={{ crumb: "Scoreboard" }}
        element={<MatchScoreboardPage />}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/scoreboard"
        handle={{ crumb: "Scoreboard" }}
        element={<MatchScoreboardPage />}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId/matches/:matchId/scoreboard"
        handle={{ crumb: "Scoreboard" }}
        element={<MatchScoreboardPage />}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments/:tournamentId/leaderboard"
        handle={{ crumb: "Leaderboard" }}
        element={<TournamentLeaderboardPage />}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments/:tournamentId/leaderboard"
        handle={{ crumb: "Leaderboard" }}
        element={<TournamentLeaderboardPage />}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments/:tournamentId/leaderboard"
        handle={{ crumb: "Leaderboard" }}
        element={<TournamentLeaderboardPage />}
      />
      <Route
        path="/individual-tournament/:individualTournamentId/match-manager/:managerId/tournaments/:tournamentId/leaderboard"
        handle={{ crumb: "Leaderboard" }}
        element={<TournamentLeaderboardPage />}
      />
      <Route
        path="/org/:organizationId/match-manager/:managerId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagerTournamentsPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/community/:communityId/match-manager/:managerId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagerTournamentsPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route
        path="/club/:clubId/match-manager/:managerId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={roleGuard(<MatchManagerTournamentsPage />, ['match_manager', 'tournament_admin', 'organization_admin', 'community_admin', 'club_admin', 'super_admin'])}
      />
      <Route path={`${auctionManagementPath}/online`} handle={{ crumb: "Online Auction" }}
        element={<OnlineAuctionSetupPage />} />
      <Route path={`${communityAuctionManagementPath}/online`} handle={{ crumb: "Online Auction" }}
        element={<OnlineAuctionSetupPage />} />
      <Route path={`${clubAuctionManagementPath}/online`} handle={{ crumb: "Online Auction" }}
        element={<OnlineAuctionSetupPage />} />
      <Route path={`${individualAuctionManagementPath}/online`} handle={{ crumb: "Online Auction" }}
        element={<OnlineAuctionSetupPage />} />
      <Route path={`${auctionManagementPath}/live`} handle={{ crumb: "Live Auction" }}
        element={<LiveAuctionSetupPage />} />
      <Route path={`${communityAuctionManagementPath}/live`} handle={{ crumb: "Live Auction" }}
        element={<LiveAuctionSetupPage />} />
      <Route path={`${clubAuctionManagementPath}/live`} handle={{ crumb: "Live Auction" }}
        element={<LiveAuctionSetupPage />} />
      <Route path={`${individualAuctionManagementPath}/live`} handle={{ crumb: "Live Auction" }}
        element={<LiveAuctionSetupPage />} />
      <Route
        path={`${auctionManagementPath}/online/team-owner-admins`}
        handle={{ crumb: "Team Owner Admins" }}
        element={<TeamOwnerAdminsPage />}
      />
      <Route
        path={`${communityAuctionManagementPath}/online/team-owner-admins`}
        handle={{ crumb: "Team Owner Admins" }}
        element={<TeamOwnerAdminsPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/online/team-owner-admins`}
        handle={{ crumb: "Team Owner Admins" }}
        element={<TeamOwnerAdminsPage />}
      />
      <Route
        path={`${auctionManagementPath}/online/team-owner-bidding`}
        handle={{ crumb: "Team Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path={`${communityAuctionManagementPath}/online/team-owner-bidding`}
        handle={{ crumb: "Team Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/online/team-owner-bidding`}
        handle={{ crumb: "Team Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path={`${auctionManagementPath}/live/owner-bidding`}
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path={`${communityAuctionManagementPath}/live/owner-bidding`}
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/live/owner-bidding`}
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path={`${individualAuctionManagementPath}/live/owner-bidding`}
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path="/org/:organizationId/tournaments/:tournamentId/live/owner-bidding"
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path="/community/:communityId/tournaments/:tournamentId/live/owner-bidding"
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route
        path="/club/:clubId/tournaments/:tournamentId/live/owner-bidding"
        handle={{ crumb: "Owner Bidding" }}
        element={<TeamOwnerBiddingPage />}
      />
      <Route path={`${auctionManagementPath}/online/start`} handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />} />
      <Route
        path={`${communityAuctionManagementPath}/online/start`}
        handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />}
      />
      <Route
        path={`${clubAuctionManagementPath}/online/start`}
        handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />}
      />
      <Route path={`${auctionManagementPath}/online/start/:tab`} handle={{ crumb: ":Tab" }}
        element={<StartOnlineAuctionPage />} />
      <Route
        path={`${communityAuctionManagementPath}/online/start/:tab`}
        handle={{ crumb: ":Tab" }}
        element={<StartOnlineAuctionPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/online/start/:tab`}
        handle={{ crumb: ":Tab" }}
        element={<StartOnlineAuctionPage />}
      />
      <Route
        path={`${individualAuctionManagementPath}/online/start`}
        handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />}
      />
      <Route
        path={`${individualAuctionManagementPath}/online/start/:tab`}
        handle={{ crumb: ":Tab" }}
        element={<StartOnlineAuctionPage />}
      />
      <Route path={`${auctionManagementPath}/live/start`} handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />} />
      <Route
        path={`${communityAuctionManagementPath}/live/start`}
        handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />}
      />
      <Route
        path={`${clubAuctionManagementPath}/live/start`}
        handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />}
      />
      <Route
        path={`${individualAuctionManagementPath}/live/start`}
        handle={{ crumb: "Start Match" }}
        element={<Navigate to="shuffle" replace />}
      />
      <Route path={`${auctionManagementPath}/live/start/:tab`} handle={{ crumb: ":Tab" }}
        element={<StartLiveAuctionPage />} />
      <Route
        path={`${communityAuctionManagementPath}/live/start/:tab`}
        handle={{ crumb: ":Tab" }}
        element={<StartLiveAuctionPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/live/start/:tab`}
        handle={{ crumb: ":Tab" }}
        element={<StartLiveAuctionPage />}
      />
      <Route
        path={`${individualAuctionManagementPath}/live/start/:tab`}
        handle={{ crumb: ":Tab" }}
        element={<StartLiveAuctionPage />}
      />
      <Route path={`${auctionManagementPath}/live/operator`} element={<LiveAuctionOperatorPage />} />
      <Route path={`${communityAuctionManagementPath}/live/operator`} element={<LiveAuctionOperatorPage />} />
      <Route path={`${clubAuctionManagementPath}/live/operator`} element={<LiveAuctionOperatorPage />} />
      <Route path={`${individualAuctionManagementPath}/live/operator`} element={<LiveAuctionOperatorPage />} />
      <Route
        path={`${auctionManagementPath}/online/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<AuctionTeamDetailPage />}
      />
      <Route
        path={`${communityAuctionManagementPath}/online/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<AuctionTeamDetailPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/online/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<AuctionTeamDetailPage />}
      />
      <Route
        path={`${auctionManagementPath}/live/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<LiveAuctionTeamDetailPage />}
      />
      <Route
        path={`${communityAuctionManagementPath}/live/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<LiveAuctionTeamDetailPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/live/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<LiveAuctionTeamDetailPage />}
      />
      <Route
        path={`${individualAuctionManagementPath}/live/start/teams/:teamSlug`}
        handle={{ crumb: ":Teamslug" }}
        element={<LiveAuctionTeamDetailPage />}
      />
      <Route path={`${auctionManagementPath}/teams`} handle={{ crumb: "Teams" }}
        element={<AuctionTeamSetupPage />} />
      <Route path={`${communityAuctionManagementPath}/teams`} handle={{ crumb: "Teams" }}
        element={<AuctionTeamSetupPage />} />
      <Route path={`${clubAuctionManagementPath}/teams`} handle={{ crumb: "Teams" }}
        element={<AuctionTeamSetupPage />} />
      <Route path={`${individualAuctionManagementPath}/teams`} handle={{ crumb: "Teams" }}
        element={<AuctionTeamSetupPage />} />
      <Route path={`${auctionManagementPath}/teams/overview`} handle={{ crumb: "Overview" }}
        element={<AuctionTeamsOverviewPage />} />
      <Route
        path={`${communityAuctionManagementPath}/teams/overview`}
        handle={{ crumb: "Overview" }}
        element={<AuctionTeamsOverviewPage />}
      />
      <Route
        path={`${clubAuctionManagementPath}/teams/overview`}
        handle={{ crumb: "Overview" }}
        element={<AuctionTeamsOverviewPage />}
      />
      <Route path="/management/:sectionId/coming-soon" handle={{ crumb: "Coming Soon" }}
        element={<ComingSoonPage />} />
      <Route
        path="/profile"
        handle={{ crumb: "Profile" }}
        element={
          <ProfileView
            createdProfile={createdProfile}
            isLoadingProfile={isLoadingProfile}
            onRefreshProfile={onRefreshProfile}
            statusMessage={statusMessage}
          />
        }
      />
      <Route
        path="/profile/edit"
        handle={{ crumb: "Edit Profile" }}
        element={
          token ? (
            <ProfileEditView
              formData={formData}
              handleChange={handleChange}
              handleFileChange={handleFileChange}
              handleSubmit={handleSubmit}
              isLoadingProfile={isLoadingProfile}
              isSavingProfile={isSavingProfile}
              onRefreshProfile={onRefreshProfile}
              statusMessage={statusMessage}
              manageListItem={manageListItem}
              toggleAddOn={toggleAddOn}
              toggleSkillTag={toggleSkillTag}
              updateAddOnField={updateAddOnField}
            />
          ) : (
            <Navigate to="/profile" replace />
          )
        }
      />
      <Route
        path="/profile/followers"
        handle={{ crumb: "Followers" }}
        element={
          <ProfileConnectionsView
            type="followers"
            createdProfile={createdProfile}
          />
        }
      />
      <Route
        path="/profile/following"
        handle={{ crumb: "Following" }}
        element={
          <ProfileConnectionsView
            type="following"
            createdProfile={createdProfile}
          />
        }
      />
      <Route path="/players" handle={{ crumb: "Players" }}
        element={<PlayersDirectory />} />
      <Route
        path="/players/:playerId"
        handle={{ crumb: "Player profile" }}
        element={<PlayersDirectory />}
      />
      <Route
        path="/account"
        handle={{ crumb: "Account" }}
        element={
          <StaticInfoPage
            title="Account"
            description="Review your account details and profile preferences."
            badgeText="Account"
          />
        }
      />

      <Route
        path="/account/affiliation"
        handle={{ crumb: "Affiliation" }}
        element={<AccountAffiliationView />}
      />
      <Route
        path="/guidance"
        handle={{ crumb: "Guidance" }}
        element={<GuidancePage />}
      />
      <Route path="/faq" handle={{ crumb: "FAQ" }} element={<HelpCenterPage />} />
      <Route path="/faq/:faqSlug" handle={{ crumb: "FAQ" }} element={<HelpCenterPage />} />
      <Route path="/launch" handle={{ crumb: "Launch" }}
        element={<LaunchPage />} />
      <Route path="/dashboard/organization" handle={{ crumb: "Organization" }}
        element={roleGuard(<AdminDashboardRouteRedirect scope="organization" />, ['organization_admin', 'department_admin'])} />
      <Route
        path="/dashboard/organization/:organizationId/players/approvals"
        handle={{ crumb: "Player Approvals" }}
        element={roleGuard(<PlayerApprovalsPage scopeType="organization" />, ['organization_admin', 'department_admin'])}
      />
      <Route path="/dashboard/organization/:organizationId/:tab" handle={{ crumb: "Tournaments" }}
        element={roleGuard(<OrganizationTeamAdminPage />, ['organization_admin', 'department_admin'])} />
      <Route path="/dashboard/organization/:organizationId/:tab/:subTab" handle={{ crumb: "Tournaments" }}
        element={roleGuard(<OrganizationTeamAdminPage />, ['organization_admin', 'department_admin'])} />
      <Route path="/dashboard/community" handle={{ crumb: "Community" }}
        element={roleGuard(<AdminDashboardRouteRedirect scope="community" />, ['community_admin', 'department_admin'])} />
      <Route
        path="/dashboard/community/:communityId/players/approvals"
        handle={{ crumb: "Player Approvals" }}
        element={roleGuard(<PlayerApprovalsPage scopeType="community" />, ['community_admin', 'department_admin'])}
      />
      <Route path="/dashboard/community/:communityId/:tab" handle={{ crumb: "Tournaments" }}
        element={roleGuard(<CommunityTeamAdminPage />, ['community_admin', 'department_admin'])} />
      <Route path="/dashboard/community/:communityId/:tab/:subTab" handle={{ crumb: "Tournaments" }}
        element={roleGuard(<CommunityTeamAdminPage />, ['community_admin', 'department_admin'])} />
      <Route path="/dashboard/club" handle={{ crumb: "Club" }}
        element={roleGuard(<AdminDashboardRouteRedirect scope="club" />, ['club_admin', 'department_admin'])} />
      <Route
        path="/dashboard/club/:clubId/players/approvals"
        handle={{ crumb: "Player Approvals" }}
        element={roleGuard(<PlayerApprovalsPage scopeType="club" />, ['club_admin', 'department_admin'])}
      />
      <Route path="/dashboard/club/:clubId/:tab" handle={{ crumb: "Tournaments" }}
        element={roleGuard(<ClubTeamAdminPage />, ['club_admin', 'department_admin'])} />
      <Route path="/dashboard/club/:clubId/:tab/:subTab" handle={{ crumb: "Tournaments" }}
        element={roleGuard(<ClubTeamAdminPage />, ['club_admin', 'department_admin'])} />
      <Route path="/organization-admin" handle={{ crumb: "Organization Admin" }}
        element={<Navigate to="/dashboard/organization" replace />} />
      <Route path="/community-admin" handle={{ crumb: "Community Admin" }}
        element={<Navigate to="/dashboard/community" replace />} />
      <Route path="/club-admin" handle={{ crumb: "Club Admin" }}
        element={<Navigate to="/dashboard/club" replace />} />
      <Route path="/org/:organizationId/dashboard" handle={{ crumb: "Dashboard" }}
        element={roleGuard(<OrganizationTeamAdminPage />, ['organization_admin', 'department_admin'])} />
      <Route path="/community/:communityId/dashboard" handle={{ crumb: "Dashboard" }}
        element={roleGuard(<CommunityTeamAdminPage />, ['community_admin', 'department_admin'])} />
      <Route path="/club/:clubId/dashboard" handle={{ crumb: "Dashboard" }}
        element={roleGuard(<ClubTeamAdminPage />, ['club_admin', 'department_admin'])} />
      <Route
        path="/org/:organizationId/tournament-admin/:adminId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/org/:organizationId/tournament-admin/:adminId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/org/:organizationId/tournament-admin/:tournamentAdminId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/org/:organizationId/tournament-admin/:tournamentAdminId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/community/:communityId/tournament-admin/:adminId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/community/:communityId/tournament-admin/:adminId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/community/:communityId/tournament-admin/:tournamentAdminId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/community/:communityId/tournament-admin/:tournamentAdminId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/club/:clubId/tournament-admin/:adminId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/club/:clubId/tournament-admin/:adminId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/club/:clubId/tournament-admin/:tournamentAdminId/tournaments"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/club/:clubId/tournament-admin/:tournamentAdminId/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminTournamentsPage />}
      />
      <Route
        path="/org/:organizationId/managers/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<ManagementHubPage />}
      />
      <Route
        path="/community/:communityId/managers/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<ManagementHubPage />}
      />
      <Route
        path="/club/:clubId/managers/tournaments/:tournamentId"
        handle={{ crumb: "Tournaments" }}
        element={<ManagementHubPage />}
      />
      <Route path="/dashboard/tournament-admin/tournaments" handle={{ crumb: "Tournaments" }}
        element={<TournamentAdminAssignedTournamentsPage />} />
      <Route path="/tournament-admin" handle={{ crumb: "Tournament Admin" }}
        element={<Navigate to="/dashboard/tournament-admin/tournaments" replace />} />
      <Route path="/tournament-admin/:tournamentId" handle={{ crumb: "Tournament Admin" }}
        element={<TournamentAdminTournamentsPage />} />
      <Route
        path="/org/:organizationId/tournament-admin/:adminId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/org/:organizationId/tournament-admin/:tournamentAdminId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/club/:clubId/tournament-admin/:adminId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/club/:clubId/tournament-admin/:tournamentAdminId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/org/:organizationId/managers/:managerId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/community/:communityId/managers/:managerId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/club/:clubId/managers/:managerId/tournaments/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route
        path="/tournament-admin/:tournamentId/player-management"
        handle={{ crumb: "Player Management" }}
        element={<PlayerManagementPage />}
      />
      <Route path="/team-admin" handle={{ crumb: "Team Admin" }}
        element={roleGuard(<TeamAdminPlayersPage />, ['department_admin'])} />
      <Route path="/dashboard/individual" handle={{ crumb: "Individual" }}
        element={<Navigate to="/dashboard/individual/home" replace />} />
      <Route path="/dashboard/individual/home" handle={{ crumb: "Home" }}
        element={<IndividualHomePage />} />
      <Route path="/dashboard/individual/my-matches" handle={{ crumb: "My Matches" }}
        element={<IndividualMyMatchesPage />} />
      <Route path="/dashboard/individual/nearby" handle={{ crumb: "Nearby" }}
        element={<NearbyDiscoveryPage />} />
      <Route path="/discover/nearby" handle={{ crumb: "Nearby" }}
        element={<NearbyDiscoveryPage />} />
      <Route path="/dashboard/individual/streams" handle={{ crumb: "Streams" }}
        element={<StreamingDashboardPage />} />
      <Route path="/dashboard/individual/streams/operations" handle={{ crumb: "Stream ops" }}
        element={<TournamentStreamingOperationsPage />} />
      <Route path="/dashboard/individual/tournaments" handle={{ crumb: "Tournaments" }}
        element={<IndividualTournamentsPage />} />
      <Route path="/dashboard/individual/tournaments/create" handle={{ crumb: "Create" }}
        element={<IndividualTournamentCreatePage />} />
      <Route path="/dashboard/individual/tournaments/:tournamentId/edit" handle={{ crumb: "Edit" }}
        element={<IndividualTournamentEditPage />} />
      <Route
        path="/dashboard/individual/tournaments/:tournamentId/workspace"
        handle={{ crumb: "Workspace" }}
        element={<IndividualTournamentAdminPage />}
      />
      <Route
        path="/individual-tournament/:id/admin"
        handle={{ crumb: "Individual Admin" }}
        element={<IndividualTournamentAdminPage />}
      />
      <Route
        path="/dashboard/individual/tournaments/:tournamentId/matches"
        handle={{ crumb: "Matches" }}
        element={<IndividualTournamentMatchesPage />}
      />
      <Route
        path="/dashboard/individual/tournaments/:tournamentId/matches/:matchId/start"
        handle={{ crumb: "Start Match" }}
        element={<MatchStartPage />}
      />
      </Route>
      <Route path="*" handle={{ crumb: "*" }}
        element={<NotFoundPage />} />
    </Routes>
  );
}

export default AppRoutes;
